import { isObject } from '../../../../../utils/isObject.js';
import { actionModels } from '../../../../actionModels.js';

const getAvailableFields = (model, presentationType = 'card') => {
  const modelFields = Object.fromEntries(Object.entries(actionModels).map(([key, value]) => [key, value?.fields]));
  const initialFields = {
    id: [{ key: 'id', name: 'ID' }],
    card: [
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'image', name: 'Image' },
      { key: 'id', name: 'ID' }
    ]
  };

  const fieldsSource = modelFields[model] || initialFields[model] || {};
  const initialFieldsSource = Object.entries(fieldsSource)?.find(([key]) => key === presentationType)?.[1];

  return fieldsSource || initialFieldsSource;
};

export const appActionPresentationResponseMapping = {
  key: 'presentationResponseMapping',
  type: 'app',
  label: 'Response Mapping',
  description: 'Define how the response is mapped to the UI using the input variable.',
  path: 'actions[id:{{actionId}}].presentation.fields',
  shouldRun: ({ changes }) => {
    const paths = ['presentation.fields', 'meta.lastRunOn'];
    return changes?.some((change) => paths.some((path) => change?.path?.includes(path)));
  },
  context: ['appActionOutput'],
  mapContext: ({ app, action, appActionOutput }) => ({
    appName: app?.name,
    name: action?.name,
    currentValue: Object.fromEntries(Object.keys(action?.presentation?.fields || {}).map((key) => [key, action?.presentation?.fields?.[key]?.value])),
    actionDetails: {
      model: action?.model,
      operation: action?.operation || 'none',
      slug: action?.slug,
      name: action?.name,
      method: action?.api?.method
    },
    availableFields: getAvailableFields(action?.model, action?.presentation?.type),
    appActionOutput
  }),
  formatLabel: (value) => (isObject(value) ? Object.keys(value)?.join(', ') : value),
  postProcess: ({ suggestion }) => {
    const data = suggestion?.suggestion || {};
    const { suggestedValue } = data;

    const newSuggestedValue = Object.fromEntries(Object.entries(suggestedValue).map(([key, value]) => [key, { type: 'expression', value }]));
    return { ...suggestion, suggestion: { ...data, suggestedValue: newSuggestedValue } };
  },
  prompt: 'appActionPresentationResponseMapping'
};
